module.exports = __webpack_public_path__ + "tables/media/MaerskText-Bold.5e46c668.woff2";